export default __webpack_public_path__ + "static/media/4.97e393b0.jpg";